import { noopT } from "@/plugins/i18n";
import { OperationRecordType } from "./enums";

export const OperationRecordTypeI18nKeys = Object.freeze({
  [OperationRecordType.editSetting]: noopT(
    "domains.Operations.types.editSetting"
  ),
  [OperationRecordType.applyDeposit]: noopT(
    "domains.Operations.types.applyDeposit"
  ),
  [OperationRecordType.collect]: noopT("domains.Operations.types.collect"),
  [OperationRecordType.applyWithdraw]: noopT(
    "domains.Operations.types.applyWithdraw"
  ),
  [OperationRecordType.revokeOrder]: noopT(
    "domains.Operations.types.revokeOrder"
  ),
  [OperationRecordType.executeWithdraw]: noopT(
    "domains.Operations.types.executeWithdraw"
  ),
});
